import { ListManagerFrontendError } from './ListManagerFrontendError';

// Superclass for errors involving AG functions taking the wrong sort
// of data. Named not to clash with TypeError.
export class AGTypeError extends ListManagerFrontendError {
  static errorName = 'AGTypeError';
}
